import React from "react";
import { Modal, Input, Icon } from "antd";
import PropTypes from "prop-types";

/**
 * TransferToBalanceModal - Modal for converting wallet credit to member balance
 */
const TransferToBalanceModal = ({
  visible,
  record,
  balanceAmount,
  memberBalance,
  note,
  loading,
  onNoteChange,
  onCancel,
  onSubmit,
}) => {
  if (!record) return null;

  const newBalance = (memberBalance || 0) + (balanceAmount || 0);
  const isFormValid = note && note.trim() !== "";

  return (
    <Modal
      title="Transfer Wallet to Balance"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      confirmLoading={loading}
      okText="Confirm Transfer"
      okButtonProps={{ type: "primary", danger: true, disabled: !isFormValid }}
      maskClosable={false}
    >
      <div style={{ padding: "8px 0" }}>
        {/* Warning */}
        <div
          style={{
            background: "#fff7e6",
            border: "1px solid #ffd591",
            borderRadius: 6,
            padding: 12,
            marginBottom: 16,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Icon type="warning" style={{ color: "#fa8c16", fontSize: 18 }} />
            <strong style={{ color: "#d46b08" }}>
              Warning: This action cannot be undone!
            </strong>
          </div>
          <p style={{ margin: "8px 0 0", fontSize: 13, color: "#ad6800" }}>
            The wallet will be disabled and the credit value will be added to the
            member's balance.
          </p>
        </div>

        {/* Wallet Info */}
        <div
          style={{
            background: "#f5f5f5",
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
          }}
        >
          <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
            WALLET
          </div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>
            {record.package_name || "N/A"}
          </div>
          <div
            style={{
              marginTop: 8,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span style={{ color: "#666" }}>Credit:</span>
            <span>
              <strong>{(record.credit_available || 0).toLocaleString()}</strong>{" "}
              credits
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: "#666" }}>Unit Price:</span>
            <span>
              <strong>${(record.unit_price || 0).toFixed(4)}</strong>
            </span>
          </div>
        </div>

        {/* Balance Amount */}
        <div
          style={{
            background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
            borderRadius: 8,
            padding: 16,
            color: "#fff",
            marginBottom: 16,
          }}
        >
          <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 4 }}>
            BALANCE TO ADD
          </div>
          <div style={{ fontSize: 28, fontWeight: 700 }}>
            $
            {(balanceAmount || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
          <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>
            Package Amount
          </div>
        </div>

        {/* Current Balance Info */}
        <div
          style={{
            background: "#f6ffed",
            border: "1px solid #b7eb8f",
            borderRadius: 6,
            padding: 12,
            marginBottom: 16,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontSize: 12, color: "#666" }}>Current Balance</div>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#52c41a" }}>
              $
              {(memberBalance || 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
          <Icon type="arrow-right" style={{ fontSize: 18, color: "#52c41a" }} />
          <div>
            <div style={{ fontSize: 12, color: "#666" }}>New Balance</div>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#52c41a" }}>
              $
              {newBalance.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </div>

        {/* Note */}
        <div>
          <div
            style={{
              fontSize: 12,
              color: "#666",
              marginBottom: 8,
              textTransform: "uppercase",
              letterSpacing: 0.5,
            }}
          >
            Note <span style={{ color: '#ff4d4f' }}>*</span>
          </div>
          <Input.TextArea
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
            placeholder="Reason for transferring to balance..."
            rows={2}
            style={{ borderRadius: 6 }}
          />
        </div>
      </div>
    </Modal>
  );
};

TransferToBalanceModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  record: PropTypes.object,
  balanceAmount: PropTypes.number,
  memberBalance: PropTypes.number,
  note: PropTypes.string,
  loading: PropTypes.bool,
  onNoteChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

TransferToBalanceModal.defaultProps = {
  record: null,
  balanceAmount: 0,
  memberBalance: 0,
  note: "",
  loading: false,
};

export default TransferToBalanceModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/modals/TransferToBalanceModal.js